(function (global){
'use strict';

var angular = (typeof window !== "undefined" ? window['angular'] : typeof global !== "undefined" ? global['angular'] : null);

/**
 * @ngInject
 */
function SpinbuttonDirective($timeout, Key) {
  // Runs during compile
  return {
    scope: {
      // Attention l'attribut 'spinButton' correspond au nom du model
      spinButton: '=',
      spinButtonValue: '=',
      type: '@',
      ariaLabeledby: '@'
    },
    require:'^spinbuttonGroup',
    template: '<div role="spinbutton" class="spin-control" data-type="{{dataType}}" aria-valuenow="{{spinButton}}" aria-valuemin="0" aria-valuemax="{{limitLogement}}" aria-labeledby="{{ariaLabeledby}}"  aria-describedby="alertLimitLogements" tabindex="0">' +
          '<button tabindex="-1" ng-click="lessValue()" type="button" class="button less"><span>-</span></button>' +
          '<div class="value">' +
            '<span tabindex="-1" class="control">{{spinButtonValue}}</span>' +
          '</div>' +
          '<button tabindex="-1" ng-click="moreValue()" type="button" class="button more"><span>+</span></button>' +
        '</div>',
    replace: true,

    link: function($scope, iElm, iAttrs, controller) {
      $scope.spinButton = $scope.spinButtonValue;
      var keyboard = angular.element(iElm[0]);

      /**
       * fonction moins du spinButton
       */
      $scope.lessValue = function() {

        if ($scope.spinButtonValue > 0) {
          $scope.spinButtonValue--;
          if ($scope.isLogement()) {
            controller.lessRoom();
            controller.hideAlertMessage();
          }
        }
        $scope.spinButton = $scope.spinButtonValue;

      };

      /**
       * fonction ajout du spinButton
       */
      $scope.moreValue = function() {

        if ($scope.isLogement()) {
          if ($scope.$parent.booking.total < $scope.$parent.limitLogement) {
            $scope.spinButtonValue++;
            controller.moreRoom();
            controller.hideAlertMessage();
          }else {
            controller.showAlertMessage();
          }
        } else{
          $scope.spinButtonValue++;
        }

        $scope.spinButton = $scope.spinButtonValue;

      };

      /**
       * Test si le spinButton est celui d'un logement
       * @return {Boolean} [description]
       */
      $scope.isLogement = function() {
        var _return = false;
        // @todo corriger ce test foireux avec l'espace à la fin...
        if ($scope.type === 'logement ') {
          _return = true;
        }
        return _return;
      };

      /**
       *
       */
      keyboard.bind('keydown',function(e) {
        $timeout(function() {
          $scope.$apply();
        });
        switch(e.keyCode){
          case Key.Left:
            e.preventDefault();
            return $scope.lessValue();
          case Key.Down:
            e.preventDefault();
            return $scope.lessValue();
          case Key.Up:
            e.preventDefault();
            return $scope.moreValue();
          case Key.Right:
            e.preventDefault();
            return $scope.moreValue();
        }
      });

    }

  };
}
SpinbuttonDirective.$inject = ["$timeout", "Key"];

module.exports = SpinbuttonDirective;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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